import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { PersistGate } from 'redux-persist/lib/integration/react';

import ForgotPassword from '@legacy-components/layouts/ForgotPassword';
import Login from '@legacy-components/layouts/Login';
import TwoFa from '@legacy-components/layouts/TwoFa';
import EventProvider from '@legacy-providers/event/EventProvider';
import axios from '@legacy-services/api';

import { Toaster } from '@shared/ui/components/Toast';

import { AdminLayout } from '@admin/layout/components/AdminLayout';

import { CompanyLayout } from '@company/layout/CompanyLayout';

import { isLoggedIn, selectUser } from './redux/auth/selectors';
import { persistor } from './redux/store';
import { selectIsStarting } from './redux/system/selectors';
import './styles/custom/style.scss';
import './styles/tailwind/tailwind.css';
import './styles/vendor/fullcalendar.bundle.css';
import './styles/vendor/metronic-vendors.bundle.css';

const queryClient = new QueryClient();

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      styleSheet: '/assets/css/company.css',
    };

    this._checkAccess = this._checkAccess.bind(this);
  }

  static propTypes = {
    isStarting: PropTypes.bool,
  };

  UNSAFE_componentWillMount() {
    this._checkAccess(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextprops) {
    this._checkAccess(nextprops);
  }

  _setStyle(type) {
    if (type === 'company') {
      document.getElementById('companySheet').disabled = false;
      document.getElementById('adminSheet').disabled = true;
    } else {
      document.getElementById('companySheet').disabled = true;
      document.getElementById('adminSheet').disabled = false;
    }
  }

  _checkAccess(props) {
    const { loggedIn, user, location, history, isStarting } = props;

    const notLoggedInPaths = ['/', '/reset-password', '/2fa'];

    if (loggedIn && !isStarting) {
      if (queryString.parse(window.location.search).redirect) {
        history.push(queryString.parse(window.location.search).redirect);
      } else {
        if (user.permissions.length > 0) {
          if (location.pathname.startsWith('/admin')) {
            this._setStyle('admin');
          } else {
            this._setStyle('company');
          }

          notLoggedInPaths.indexOf(location.pathname) !== -1 && history.push('/admin');
        } else {
          // Company or User
          this._setStyle('company');
          notLoggedInPaths.indexOf(location.pathname) !== -1 && history.push('/welcome');
        }
      }
    } else if (!loggedIn && !isStarting) {
      this._setStyle('admin');
      notLoggedInPaths.indexOf(location.pathname) === -1 && history.push('/?redirect=' + window.location.pathname);
    }

    if (!isStarting) {
      const element = document.getElementById('loader');

      if (element) {
        element.parentNode.removeChild(element);
      }
    }
  }

  render() {
    if (!this.props.isStarting) {
      return (
        <PersistGate persistor={persistor}>
          <ToastContainer autoClose={8000} />
          <QueryClientProvider client={queryClient}>
            <EventProvider>
              <Switch>
                <Route exact path="/" component={Login} />
                <Route exact path="/2fa" component={TwoFa} />
                <Route exact path="/reset-password" component={ForgotPassword} />
                <Route path="/admin" component={AdminLayout} />
                <Route path="/" component={CompanyLayout} />
              </Switch>
            </EventProvider>
            <ReactQueryDevtools initialIsOpen={false} panelProps={{ style: { height: '400px' } }} />
          </QueryClientProvider>
          <Toaster />
        </PersistGate>
      );
    }

    return null;
  }
}

const mapStateToProps = function (store) {
  return {
    loggedIn: isLoggedIn(store),
    isStarting: selectIsStarting(store),
    user: selectUser(store),
  };
};

export default flowRight(withRouter, connect(mapStateToProps))(App);
